<div class="sort-clear-container">
  <ion-button
    data-cy="add-to-list-button"
    [class]="isSelected ? 'usf-fill-green-button' : 'usf-outline-green-button'"
    [class.mobile-width]="platformType === platformEnum.mobile"
    class="add-to-list"
    (click)="addtoList()"
    *ngIf="platformType === platformEnum.mobile && onRecentPurchase"
  >
    + {{ 'i18n.lists.addToList' | translate }}
  </ion-button>
  <ion-button
    *ngIf="platformType === platformEnum.mobile && showAddButton"
    data-cy="add-products-button"
    class="usf-outline-green-button add-to-list"
    [class.mobile-width]="platformType === platformEnum.mobile"
    (click)="onAddProductClick()"
  >
    {{ 'i18n.common.addProducts' | translate }}
    <ion-icon
      class="arrow-icon"
      src="assets/icon/ios-arrow-down.svg"
      slot="end"
    ></ion-icon>
  </ion-button>

  <ion-button
    data-cy="sort-filter-button"
    class="usf-outline-green-button"
    [disabled]="disabled"
    (click)="openSortAndFilterListModal()"
    [class.mobile-width]="platformType === platformEnum.mobile"
    [class.full-width]="buttonFullWidth"
  >
    <ion-icon
      data-cy="sort-filter-button-icon"
      slot="start"
      name="filter"
    ></ion-icon>
    <span data-cy="sort-filter-button-text">
      {{ sortAndFilterText | translate }}
      <span *ngIf="sortAndFilterCount > 0" data-cy="sort-filter-count"
        >({{ sortAndFilterCount }})</span
      >
    </span>
  </ion-button>
  <div
    class="clear-all-button"
    [class.disabled]="disabled"
    (click)="clearSortAndFilter()"
    *ngIf="showClearAll"
  >
    {{ 'i18n.common.clearAll' | translate }}
  </div>
</div>
